<template>
  <v-row ref="editForm" class="edit-form" no-gutters>

    <v-col cols="12" sm="6">
      <v-text-field ref="email"
                    v-model.trim="userForm.email"
                    v-validate="'required|email'"
                    :error-messages="errors.collect('email')"
                    data-vv-as="E-Mail"
                    class="required"
                    name="email"
                    label="E-Mail"
                    @change="$emit('mailChange', userForm.email)"/>
    </v-col>

    <v-col cols="12" sm="6">
      <v-text-field v-model.trim="confirmMail"
                    v-validate="'required|email|confirmed:email'"
                    :error-messages="errors.collect('email2')"
                    data-vv-as="Bestätigung der E-Mail"
                    class="required"
                    name="email2"
                    label="E-Mail bestätigen"/>
    </v-col>

    <v-col cols="12" sm="6">
      <v-text-field v-model="userForm.tel"
                    v-validate="{ required: true, regex: regex.telefon }"
                    :error-messages="errors.collect('tel')"
                    data-vv-as="Festnetz- / Mobilnummer"
                    class="required"
                    name="tel"
                    label="Festnetz- / Mobilnummer" />
    </v-col>

    <v-col cols="12" sm="6">
      <v-text-field v-model="userForm.mobile"
                    v-validate="{ regex: regex.telefon }"
                    :error-messages="errors.collect('mobil')"
                    data-vv-as="Festnetz- / Mobilnummer"
                    name="mobil"
                    label="Alternative Festnetz- / Mobilnummer" />
    </v-col>

    <v-col cols="12" sm="6">
      <v-text-field v-model="userForm.fax"
                    v-validate="{ regex: regex.telefon }"
                    :error-messages="errors.collect('fax')"
                    data-vv-as="Fax"
                    name="fax"
                    label="Fax" />
    </v-col>

  </v-row>
</template>
<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import REGEX from "@/validation/regexes";
export default {
  name: "EditKontakt",
  mixins: [ ValidationMixin ],
  props: {
    userForm: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      confirmMail: '',
      regex: REGEX
    };
  },
  mounted: function () {
    if (this.userForm)
      this.confirmMail = this.userForm.email;
  }
};
</script>
